import * as util from '../apiUtils';
import * as common from '../apiCommon';
import * as DocType from '../../constants/constant_doc_types';

export function fetchDeviceTypeDropdown(app, params) {
  const { searchTerm, searchParams, fields, id } = params;
  const dropdown_type = 'device_type/dropdown';
  const query = {
    id,
    dropdown_type,
    fields,
    searchTerm,
    searchParams
  };

  return common.getDropdownList(app, { query });
}

export function saveDeviceType(app, dataToSave) {
  const { user = {}, data } = dataToSave;

  let deviceTypeData = {
    doc_type: DocType.DEVICE_TYPE,
    cid: data.cid || '',
    name: util.toStringText(data.name),
    short_name: util.toStringText(data.short_name),
    active: util.toBoolean(data.active),
    lockout_period: util.toInteger(data.lockout_period),
    output_device: util.toBoolean(data.output_device),
    system_defined: util.toBoolean(data.system_defined)
  };

  return common.saveDoc(app, {
    source: data,
    doc: deviceTypeData,
    user,
  });

}

export function deleteDeviceType(app, data) {
  return common.deleteDoc(app, {
    id: data.id,
    docType: DocType.DEVICE_TYPE
  });
}

export function fetchDeviceTypeById(app, params) {
  const { id } = params;
  const docType = DocType.DEVICE_TYPE;
  return common.getDoc(app, { id, docType });
}
